import React, { useState, useCallback } from 'react';
import { ButtonDropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import { CompanyStatus } from '../Helpers/enums';
import { updateCompanyStatus } from '../Services/companyService';

const CompanyStatusButtons = ({ company, refresh }) => {
  const [isOpen, setIsOpen] = useState(false);
  const { t } = useTranslation('translations');

  const toggle = useCallback(() => {
    setIsOpen(!isOpen);
  }, [isOpen]);

  const CompanyStatusButton = ({ color, status, children }) => (
    <ButtonDropdown isOpen={isOpen} toggle={toggle}>
      <DropdownToggle caret size="xs" outline color={color}>
        {status}
      </DropdownToggle>
      <DropdownMenu>{children}</DropdownMenu>
    </ButtonDropdown>
  );

  const changeCompanyStatus = (companyStatus) => {
    updateCompanyStatus(company.id, companyStatus)
      .then(() => {
        refresh();
      })
      .catch((error) => {
        console.error('Error updating company status:', error);
      });
  };

  const companyStatus = company.companyStatus;
  const renderButton = () => {
    switch (companyStatus) {
      case CompanyStatus.WaitingForVerification:
        return (
          <CompanyStatusButton color="warning" status="Waiting for verification">
            {actions()}
          </CompanyStatusButton>
        );
      case CompanyStatus.New:
        return (
          <CompanyStatusButton color="primary" status="New">
            {actions()}
          </CompanyStatusButton>
        );
      case CompanyStatus.Rejected:
        return (
          <CompanyStatusButton color="danger" status="Rejected">
            {actions()}
          </CompanyStatusButton>
        );
      case CompanyStatus.Verified:
        return (
          <CompanyStatusButton color="success" status="Verified">
            {actions()}
          </CompanyStatusButton>
        );
      case CompanyStatus.Blocked:
        return (
          <CompanyStatusButton color="danger" status="Blocked">
            {actions()}
          </CompanyStatusButton>
        );
      default:
        return null;
    }
  };

  const actions = () => {
    return (
      <>
        <DropdownItem onClick={() => changeCompanyStatus('Verify')}>
          <b>Verify</b>
        </DropdownItem>
        <DropdownItem divider />
        <DropdownItem onClick={() => changeCompanyStatus('Reject')}>
          <b>Reject</b>
        </DropdownItem>
        <DropdownItem divider />
        <DropdownItem onClick={() => changeCompanyStatus('New')}>
          <b>New</b>
        </DropdownItem>
        <DropdownItem divider />
        <DropdownItem onClick={() => changeCompanyStatus('Block')}>
          <b>Block</b>
        </DropdownItem>
      </>
    );
  };

  return <>{renderButton()}</>;
};

export default CompanyStatusButtons;
